<template>
  <div>
    <OrderAccount
      :orderId="orderData.id"
      @orderAccountSaveSuccess="handleOrderAccountSaveSuccess"
      @orderAccountSubmitSuccess="handleOrderAccountSubmitSuccess"
      @orderAccountSubmitFailed="handleOrderAccountSubmitFailed"
      @orderAccountCancel="handleOrderAccountCancel"
    />
  </div>
</template>
<script>
import OrderAccount from '@/bizComponents/OrderAccount/index.vue'

export default {
  inject: ['orderData'],
  components: {
    OrderAccount,
  },
  methods: {
    handleOrderAccountSaveSuccess() {
      setTimeout(() => {
        this.$refreshBack(true)
      }, 1200)
    },
    handleOrderAccountSubmitSuccess() {
      setTimeout(() => {
        this.$refreshBack(true)
      }, 1200)
    },
    handleOrderAccountSubmitFailed({ errorCode }) {
      if (errorCode === 24012) {
        // 网约钱包支付提示
        this.$confirm(
          '有正在进行中的网约钱包支付,可等待网约钱包支付完成后再进行核算或手动终止',
          '提示',
          {
            confirmButtonText: '去终止',
            cancelButtonText: '取消',
          },
        ).then(() => {
          this.$refreshBack(true)
          this.$router.push({
            path: '/finance/withholdPlanList',
          })
        }).catch(() => null)
      } else if (errorCode === 24013) {
        // 支付宝支付提示
        this.$alert(
          '有正在进行中的支付宝支付,请完成支付宝支付后再进行核算',
          '提示',
          {
            confirmButtonText: '关闭',
            callback: () => null,
          },
        )
      }
    },
    handleOrderAccountCancel() {
      this.$refreshBack(false)
    },
  },
}
</script>
